import TermsCoditions from "./termsconditions.js";

export default TermsCoditions;
